import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import commonStyles from '../styles';
import LineReceptionTableWrapper from './parts/lineReceptionTableWrapper';
import UpdateButton from '../eleCommon/updateButton';
import { reload } from '../../store/search/searchItemsSlice';
import CustomTablePagination from '../eleCommon/customTablePagenation';
import { setRequestParams } from '../../store/line/getLineReceptionListSlice';

const useStyles = makeStyles((theme) => ({
  headrWrap: {
    position: 'sticky',
    top: 0,
    left: 240,
    zIndex: 1,
    background: 'rgb(250 250 250)',
    width: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '14px 16px 6px',
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 1,
    width: 'fit-content',
  },
  ttl: {
    marginRight: 46,
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 32px',
    position: 'sticky',
    top: 53,
    left: 0,
    zIndex: 1,
    width: 'fit-content',
  },
  num: {
    fontSize: '15px',
    lineHeight: '1.6',
    letterSpacing: '0',
    marginRight: 6,
  },
  num1: {
    fontWeight: '700',
    marginRight: 4,
  },
  num2: {
    marginRight: 4,
  },
  operation: {
    position: 'relative',
    width: 108,
    height: 40,
    '& .MuiFormControl-root': {
      position: 'relative',
      zIndex: 1,
      borderBottom: 'none!important',
    },
    '& .MuiInputBase-root:before': {
      content: 'none',
    },
    '& .MuiInputBase-root:after': {
      content: 'none',
    },
    '& .MuiSelect-root': {
      height: 40,
    },
  },
  operationTxt: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    pointerEvents: 'none',
    textAlign: 'left',
    padding: '0 28px 0 20px',
    lineHeight: '40px',
    color: '#fff',
    fontSize: '15px',
    fontWeight: '700',
    letterSpacing: '0',
    borderRadius: '4px',
    background: `linear-gradient(90deg, ${theme.palette.primaryColor} 0%, ${theme.palette.gradLightColor} 100%)`,
    '&.disabled': {
      pointerEvents: 'visible',
      background: '#DEDEDE',
      color: '#AFAFAF',
      '& span': {
        borderColor: '#AFAFAF transparent transparent',
      },
    },
  },
  operationIcon: {
    width: 0,
    height: 0,
    borderWidth: '4px 4px 0',
    borderStyle: 'solid',
    borderColor: '#fff transparent transparent',
    position: 'absolute',
    top: 17,
    right: 10,
  },
}));

function LineReceptionWrapper(props) {
  const {
    list,
    count,
    page,
    setPage,
    rowsPerPage,
    setRowPages,
  } = props;

  const dispatch = useDispatch();
  const classes = useStyles();
  const baseClasses = commonStyles();
  const requestParams = useSelector((state) => state.receptionList.initialRequestParams);
  const isSp = useSelector((state) => state.deviceTypeSlice.isSp);

  // 更新処理
  const updateStart = () => {
    dispatch(reload());
    // listの更新は反響ツリーの更新でキックされる
  };

  useEffect(() => {
    const customerIds = [];
    if (list.length > 0) {
      for (let i = 0; list.length > i; i += 1) {
        customerIds.push(list[i].customerId);
      }
    }
    // PC版 - 反響ツリーに紐づく顧客のID(customerId)で 【customer021】LINE受信一覧取得 を叩く
    const copyObj = Object.assign({}, requestParams);
    copyObj.customerIds = customerIds;
    copyObj.offset = page * rowsPerPage;
    copyObj.limit = rowsPerPage;
    dispatch(setRequestParams(copyObj));
  }, [list, page, rowsPerPage, requestParams.offset]);

  return (
    <Grid className={`${classes.root}`}>
      <div className={classes.headrWrap}>
        <Grid className={classes.header}>
          <Typography
            className={`${baseClasses.title2} ${classes.ttl}`}
          >
            LINE受信一覧
          </Typography>
          <UpdateButton
            onClick={updateStart}
          />
          {!isSp && (
            <CustomTablePagination
              rowsPerPageOptions={[20, 40, 60]}
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowPages}
              totalCount={count ?? 20}
            />
          )}
        </Grid>
      </div>
      <LineReceptionTableWrapper
        rows={list}
      />
    </Grid>
  );
}

export default LineReceptionWrapper;
